import NewPayBills from 'components/nPayBills';

export default {
  exact: true,
  name: 'pay-bills',
  protected: true,
  path: '/pay-bills',
  component: NewPayBills,
};
